// extracted by mini-css-extract-plugin
export default {"address-render":"src-pages-rule-pages-detail-components-AddressRule-index-module_address-render--GksV3"};